var _path, _mask, _rect, _mask2, _rect2, _mask3, _rect3, _mask4, _rect4, _mask5, _rect5, _mask6, _rect6, _mask7, _rect7, _mask8, _rect8, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOfficetel = function SvgOfficetel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 50 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M30.348 1.162H14.136V37.02h21.679V5.3z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "officetel_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.96,
    height: 3.96,
    x: 17.066,
    y: 10.09,
    rx: 0.396
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.96,
    height: 3.96,
    x: 17.066,
    y: 10.09,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    mask: "url(#officetel_svg__a)",
    rx: 0.396
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "officetel_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.96,
    height: 3.96,
    x: 23.402,
    y: 10.09,
    rx: 0.396
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3.96,
    height: 3.96,
    x: 23.402,
    y: 10.09,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    mask: "url(#officetel_svg__b)",
    rx: 0.396
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "officetel_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.96,
    height: 3.96,
    x: 17.066,
    y: 16.029,
    rx: 0.396
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3.96,
    height: 3.96,
    x: 17.066,
    y: 16.029,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    mask: "url(#officetel_svg__c)",
    rx: 0.396
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "officetel_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.96,
    height: 3.96,
    x: 23.402,
    y: 16.029,
    rx: 0.396
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 3.96,
    height: 3.96,
    x: 23.402,
    y: 16.029,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    mask: "url(#officetel_svg__d)",
    rx: 0.396
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "officetel_svg__e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.96,
    height: 3.96,
    x: 17.066,
    y: 21.969,
    rx: 0.396
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 3.96,
    height: 3.96,
    x: 17.066,
    y: 21.969,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    mask: "url(#officetel_svg__e)",
    rx: 0.396
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "officetel_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.96,
    height: 3.96,
    x: 23.402,
    y: 21.969,
    rx: 0.396
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 3.96,
    height: 3.96,
    x: 23.402,
    y: 21.969,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    mask: "url(#officetel_svg__f)",
    rx: 0.396
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "officetel_svg__g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.96,
    height: 3.96,
    x: 17.023,
    y: 4.18,
    rx: 0.396
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 3.96,
    height: 3.96,
    x: 17.023,
    y: 4.18,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    mask: "url(#officetel_svg__g)",
    rx: 0.396
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "officetel_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.96,
    height: 3.96,
    x: 23.359,
    y: 4.18,
    rx: 0.396
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 3.96,
    height: 3.96,
    x: 23.359,
    y: 4.18,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    mask: "url(#officetel_svg__h)",
    rx: 0.396
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M30.416 1.16v35.858"
  })));
};
export default SvgOfficetel;